<mat-card style="border-color: #5775a8;">

  <mat-card-header>

    <div class="flex flex-col rounded-lg w-full">
      <span style="font-size: small;">This page contains Annual Inspection information related to the Business</span>
      <div class="flex flex-row rounded-lg w-full" style="background-color: #5775a8;padding-left: 20px;align-items: center;">
        <div class="flex w-full" >
          <span style="color: white;">
            Annual Inspections
          </span>
        </div>

        <div class="flex flex-col" style="padding-right: 20px;">
          <button mat-raised-button (click)="add()" class="m-8 container" style="background: #7ABDF3;">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="inspectionType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Type</th>
              <td mat-cell *matCellDef="let inspection">
                <div *ngIf="inspection.inspectionType > 0">
                  <span *ngIf="inspection.inspectionType == 1">Initial</span>
                  <span *ngIf="inspection.inspectionType == 2">Follow Up
                    <span class="text-danger">
                      <br />
                      <strong>Remediation Plan Due: </strong>{{inspection.requiredImplementationDate}}
                      <br />
                      <strong>Site Visit Due:</strong> {{inspection.requiredVisitDate}}
                    </span>
                  </span>
                  <span *ngIf="inspection.InspectionType == 3">Post Remediation Plan</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="visitDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Date</th>
              <td mat-cell *matCellDef="let inspection">
                {{inspection.visitDate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="followupConducted">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Conducted</th>
              <td mat-cell *matCellDef="let inspection">
                <span *ngIf="inspection.followupConducted == null"></span>
                <span *ngIf="inspection.followupConducted == 1">Yes</span>
                <span *ngIf="inspection.followupConducted == 0" class="text-danger">No</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="visitConductedReason">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Results/Reason</th>
              <td mat-cell *matCellDef="let inspection">
                <div *ngIf="inspection.followupConducted == 0">
                  <div *ngIf="inspection.inspectionType ==1">
                    <span *ngIf="inspection.visitConductedReason == 1" class="text-danger">Site Visit Denied (Forwarded to
                      OHA)</span>
                    <span *ngIf="inspection.visitConductedReason == 2" class="text-danger">Failure to develop Remediation Plan
                      (Forwarded to OHA)</span>
                    <span *ngIf="inspection.visitConductedReason == 3" class="text-danger">Other - Explain in Comments</span>
                  </div>
                  <div *ngIf="inspection.inspectionType ==2">
                    <span class="text-danger">Explained in Comments</span>
                  </div>
                  <div *ngIf="inspection.inspectionType ==3">
                    <span class="text-danger">Explained in Comments</span>
                  </div>

                </div>
                <div *ngIf="inspection.followupConducted == 1">
                  <!-- Initial Results -->
                  <div *ngIf="inspection.inspectionType ==1">
                    <span *ngIf="inspection.remediationResult == 1">No Violations Found</span>
                    <span *ngIf="inspection.remediationResult == 2" class="text-danger">Violations Found</span>
                  </div>
                  <!-- Follow up Results -->
                  <div *ngIf="inspection.inspectionType ==2">
                    <span *ngIf="inspection.remediationResult == 1">The business completed the remediation plan successfully
                      (complaint resolved).</span>
                    <span *ngIf="inspection.remediationResult == 2" class="text-danger">The remediation plan was not
                      completed</span>
                    <span *ngIf="inspection.remediationResult == 3" class="text-danger">The remediation plan was completed and
                      another violation was observed</span>
                    <span *ngIf="inspection.remediationResult == 4" class="text-danger">The remediation plan was not completed
                      successfully and additional violations were observed</span>

                  </div>
                  <!-- Post Remediation Results -->
                  <div *ngIf="inspection.inspectionType ==3">

                    <span *ngIf="inspection.remediationResult == 1">No Violations Found</span>
                    <span *ngIf="inspection.remediationResult == 2" class="text-danger">Violations observed</span>
                  </div>
                </div>

              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let inspection">
                <div class="flex flex-row">
                  <a (click)="editInspection(inspection)"><mat-icon>edit</mat-icon></a>
                  <a (click)="deleteInspection(inspection)" style="color:red;"><mat-icon>delete</mat-icon></a>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>
        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator> -->
      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>